<!--
 * @Description: 系统导入服务事项dialog组件
 * @Author:sunhuihong
 * @Date: 2022-05-30 16:27:42
 * @LastEditTime: 2022-06-06 18:27:10
-->
<template>
  <div class="body">
    <el-dialog width="800px" :title="dialogTitle" :visible.sync="showMatterImport" :close-on-click-modal="false"
      :before-close="handleCancel" class="import-dialog-main" @open="initData">
      <el-row style="padding: 20px 30px;" :gutter="0" type="flex" justify="space-between" align="middle">
        <el-col :span="12" style="text-align: left">
          <span class="search-title">所属机构：</span>
          <el-select size="small" style="width: 240px" v-model="filterParams.instiutionId" clearable filterable 
            placeholder="请选择" 
            :filter-method="(value) => commonUtil.handleListFilter(value, 'institutionsList', srcInstitutionList, this)"
					  @visible-change="(visible) => 
              commonUtil.handleListFilterVisibleChange(visible, 'institutionsList', srcInstitutionList, this)">
            <el-option v-for="item in institutionsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <el-button size="small"  @click="handleQuery" type="primary" icon="el-icon-search">搜 索</el-button>
        </el-col>
      </el-row>
      <div class="main-content" v-if="treeData.length"   style="border: 1px solid #D3D3D3;">
        <el-row >
          <el-col :span="8" style="padding: 24px 28px 30px 24px; border-right: 1px solid #D3D3D3;">
            <div style="line-height: 35px; display: flex; justify-content: space-between;">
              <span class="service-title">注意事项组</span>
              <el-checkbox  v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            </div>
            <el-input placeholder="输入关键字进行过滤" size="small" v-model="filterText" style="margin: 5px 0 15px 0;"></el-input>
            <el-tree class="tree-style" :data="treeData" node-key="id" show-checkbox  :props="defaultProps"  ref="treeData" 
              :default-expanded-keys="defautIdList" :filter-node-method="filterNode" :default-checked-keys="defaultCheckedKeysList"  
              @node-click="deptNodeClick" @check="handleCheckedMatterItem">
            </el-tree>
            <div style="margin: 50px 0 30px 0;">
              <el-button size="small" style="width: 80px;" @click="handleResetChecked">取 消</el-button>
              <el-button type="primary" style="width: 80px;" size="small" @click="handleMatterImport">导入</el-button>
            </div>
          </el-col>
          <el-col :span="16" style="text-align:left" >
            <div style="padding: 24px 34px 60px 35px;">
              <div style="margin: 6px 0 10px 0; font-weight: 400; color: #657180;">注意事项:</div>
              <el-input  type="textarea" ref="content" v-model="content" disabled maxlength="500" :rows="20" style="width: 80%;">
              </el-input>
            </div>
          </el-col>
        </el-row>
      </div> 
      <div  v-else style="margin-top: 30px; padding-bottom: 100px;">
        <el-empty :image-size="160"></el-empty>
      </div>   
    </el-dialog>
  </div>
</template>
<script>
import Constant from '@/global/Constant.js'

export default {
  name: "matterImport",
  props: ["showMatterImport", "institutionId"],
  data() {
    return {
      content: null,
      filterText: '',
      dialogTitle: '选择服务事项' ,
      institutionsList: [],
      srcInstitutionList: [],
      defautIdList: [],//默认展开的id集合
      defaultCheckedKeysList: [],//默认选中的id集合
      filterParams: {
        instiutionId: 0,
      },
      checkAll: false,//是否全选
      treeData: [],
      defaultProps: {
        children: 'matterCfgDTOList',
        label: 'name',
      }  
    }
  },

  methods: {
    async initData() {
      await this.getFilterDo();
      await this.listHsvcMatterTree();
    },

    //获取过滤条件数据
    getFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant. URL_GET_MATTER_FILTER_DO).then(result => {
          if (result != null) {
            this.institutionsList = result.data;
            this.srcInstitutionList = result.data;
            this.filterParams.instiutionId = this.institutionId;
            resolve();
          }
        })
      })
    },

    //获取指定机构下得服务组类数据
    listHsvcMatterTree() {
      return new Promise((resolve) => {
        let header = this.encryptionUtil.signatureParams(this.filterParams,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_IPMORT_MATTER_TREE,
          param: this.filterParams,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.treeData = result.data;
            this.defautIdList = this.treeData.length > 0 ? [this.treeData[0].id] : this.defautIdList;
            this.defaultCheckedKeysList = this.treeData.length > 0 && this.treeData[0].matterCfgDTOList.length > 0 
              ? [this.treeData[0].matterCfgDTOList[0].id] : this.defaultCheckedKeysList;
            this.content =  this.treeData.length > 0 && this.treeData[0].matterCfgDTOList.length > 0 
              ? this.treeData[0].matterCfgDTOList[0].content : this.content;
            resolve();
          }
        })
      })
    },

    //全选
    handleCheckAllChange() {
      if (this.checkAll) {
        this.$refs.treeData.setCheckedNodes(this.treeData);
      } else {
        this.$refs.treeData.setCheckedKeys([]);
      }
    },

    //取消
    handleResetChecked() {
      this.$refs.treeData.setCheckedKeys([]);
      this.$emit("close-dialog", false);        
    },

    //导入
    handleMatterImport() {
      let matterList = this.getCheckedMatterList();
      if (matterList.length == 0) {
        this.$message.error( "请选择需要导入的服务事项！")
        return false;
      }
      let params = {
        instiutionId: this.filterParams.instiutionId,
        matterList: matterList
      };
      let header = this.encryptionUtil.signatureBody(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'POST',
        url: Constant.URL_SAVE_IMPORT_MATTERS_FORM_CFG,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_JSON,
      };
      this.vueRequest(requestData).then((_result) => {
        this.clearData();
        this.$emit("handle-close-import-dialog", true);  
      });
    },

    getCheckedMatterList() {
      let data = this.$refs.treeData.getCheckedNodes();//已经选中的数据集合
			let matterDates = data.filter(item => item.matterCfgDTOList.length == 0);
      let newMatterDates = [] ;
      matterDates.forEach(item => { 
      let parentId = newMatterDates.find((i) => i.parentId == item.parentId) ;
      if (!parentId) {
        newMatterDates.push({ parentId: item.parentId, childIdList: [item.id] }) 
      } else { 
        parentId.childIdList.push(item.id) 
      } 
    })
      return newMatterDates;
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },

    //当el-tree复选框被点击的时候触发data为当前点击得项，checkedData为所有已经选中得项
    handleCheckedMatterItem(data,_checkedData) {
      this.content = data.content;
    },
    
    deptNodeClick(item,_e) {
      this.content = item.content;
    },

    clearData() {
      if(this.treeData)return;
      this.$refs.treeData.setCheckedKeys([]);
      this.content = '';
    },

    handleCancel() {
      this.clearData();
      this.$emit("handle-close-import-dialog", false);        
    },

    //搜索机构
    handleQuery() {
      this.listHsvcMatterTree();
    },
  },

  watch: {
    filterText(val) {
      this.$refs.treeData.filter(val);
    },
  },
}
</script>
<style> 
.el-scrollbar .el-scrollbar__wrap {
  overflow-x: hidden;
} 
</style>
<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.search-title {
  color: #657180;
  font-size: 14px;
}

.main-line {
  height: 10px;
  background-color: #f0f0f0;
}

.import-dialog-main /deep/ .el-dialog__body {
  padding: 0px !important;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

.main-content {
  padding:0 10px;
}

.empty-image {
  width: 300px;
  height: 300px;
}

.tree-style {
  height: 300px;
  overflow-y: auto;
}

 
</style>





// WEBPACK FOOTER //
// src/components/hsvcmng/components/MatterImport.vue